import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IGetRemainingUserQuotaParams {
}

export interface IGetRemainingUserQuotaResult {
  usersRemaining?: number;
}

export class GetRemainingUserQuotaRequest extends Request<IGetRemainingUserQuotaParams, IGetRemainingUserQuotaResult> {
  constructor() {
    super('getRemainingUserQuota', {});
  }
}
